import type { CSSProperties } from 'react';
import { useMemo } from 'react';
import styled from 'styled-components';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { MediaImage } from '@elfsight/widget-media';
import { useLocationCardProps } from './location-card-settings-context';

type LocationPhotoMediaProps = {
  useHorizontalAspectRatio?: boolean;
  horizontalPadding?: number;
  verticalPadding?: number;
  position?: 'top' | 'bottom';
};

export function LocationPhotoMedia({
  useHorizontalAspectRatio,
  horizontalPadding = 0,
  verticalPadding = 0,
  position
}: LocationPhotoMediaProps) {
  const {
    locationPhotoImage,
    locationPhotoVerticalAspectRatio,
    locationPhotoHorizontalAspectRatio,
    textColor,
    businessName
  } = useLocationCardProps();

  const style: CSSProperties | undefined = useMemo(() => {
    const width = `calc(100% + ${horizontalPadding * 2}px)`;

    if (position === 'top') {
      return {
        margin: `-${verticalPadding}px -${horizontalPadding}px 0px`,
        width
      };
    }

    if (position === 'bottom') {
      return {
        margin: `0px -${horizontalPadding}px -${verticalPadding}px`,
        width
      };
    }

    return undefined;
  }, [verticalPadding, horizontalPadding, position]);

  if (!locationPhotoImage) return null;

  const name = typeof businessName === 'string' ? businessName : undefined;

  return (
    <Container style={style}>
      <MediaImage
        src={locationPhotoImage.url}
        ratio={
          useHorizontalAspectRatio
            ? locationPhotoHorizontalAspectRatio
            : locationPhotoVerticalAspectRatio
        }
        alt={locationPhotoImage.alt ?? name}
        containerHeight="auto"
        withSkeleton
        skeletonBorderRadius={0}
        skeletonColor={getColorWithAlpha(textColor, 0.1)}
      />
    </Container>
  );
}

const Container = styled.div``;
